import LegalLayout from '../components/legal/LegalLayout'
import source, { VERSION, EFFECTIVE_DATE } from '../assets/legal/workerPrivacy'

// One document, one page, one chunk. See components/legal/LegalLayout.jsx for
// why these are not a single :slug route.

export default function LegalWorkerPrivacy() {
  return (
    <LegalLayout
      slug="worker-privacy"
      title="Worker Privacy Policy"
      version={VERSION}
      date={EFFECTIVE_DATE}
      source={source}
    />
  )
}
